import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip } from 'react-tooltip';
import { TrevorIcon } from '../TrevorIcon';
import { TooltipProps, TTooltipVariant } from './Tooltip.types';

export const TOOLTIP_VARIANT_TO_BACKGROUND: Record<TTooltipVariant, string> = {
  error: 'var(--color-feedback-error-darker)',
  success: 'var(--color-feedback-success-darkest)',
  warning: 'var(--color-feedback-warning-darker)',
  info: 'var(--color-interface-secondary-normal)',
  inactive: 'var(--color-interface-layout-darker)',
};

export const TOOLTIP_VARIANT_TO_COLOR: Record<TTooltipVariant, string> = {
  error: 'var(--color-interface-neutral-light)',
  success: 'var(--color-interface-neutral-light)',
  warning: 'var(--color-interface-neutral-light)',
  info: 'var(--color-interface-neutral-light)',
  inactive: 'var(--color-interface-content-normal)',
};

// TODO: Cannot create styled-component for component: undefined
export const TooltipContainer = styled(Tooltip || 'div')<TooltipProps>`
  --l-color: ${(p) => TOOLTIP_VARIANT_TO_COLOR[p.variant as TTooltipVariant]};
  --l-background: ${(p) =>
    TOOLTIP_VARIANT_TO_BACKGROUND[p.variant as TTooltipVariant]};

  background: var(--l-background);
  padding: var(--spacing-s) var(--spacing-m);
  border-radius: 100px;
  display: flex;
  gap: var(--spacing-s);
  align-items: center;
  color: var(--l-color);
  opacity: 1;

  > p {
    color: var(--l-color);
  }

  svg {
    flex-shrink: 0;
  }

  &.react-tooltip__place-left > div {
    margin-right: 1px;
  }

  &.react-tooltip__place-right > div {
    margin-left: 1px;
  }

  ${(props) =>
    props.isMultiline &&
    css`
      align-items: start;
      border-radius: var(--radius-8);
      max-width: 170px;
    `}
`;

export const CloseButton = styled(TrevorIcon).attrs({ name: 'close-circle' })`
  cursor: pointer;
`;
